export default {
  header: 'Oh My…',
  mainText: 'It looks like this page has been lost',
  button: 'Back to Home',
  imgAlt: 'not found page',
};
